import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  max-width: 960px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;

export const FormContainer = styled.div`
  margin: 2rem 0rem;
`;

export const ImportFileContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 1em 0 0 0;
`;

export const FooterContainer = styled.section`
  width: 100%;
  margin: 2rem 0rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    width: 100%;
  }

  p {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 18px;
    color: ${props => props.theme.secondaryColor};
    pointer-events: none;

    svg {
      margin-right: 5px;
      width: 24px;
      color: ${props => props.theme.secondaryColor};
    }
  }
`;

export const Label = styled.label`
  display: block;
  width: 100%;
  min-height: 1rem;
  font-size: 0.9rem;
  color: rgb(135, 134, 139);
  margin-bottom: 0.5rem;
`;

export const FileWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
